import { useState, useEffect } from 'react';
import './Header.css';
import logo from '../assets/logo.png';
import logoWebp from '../assets/logo-240.webp';
import { Link, NavLink,useLocation } from 'react-router-dom';

export default function Header({ isSplashActive = false }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 20);
    };

    handleScroll();
    // Add scroll event listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('mobile-menu-open');
    }
    return () => {
      document.body.classList.remove('mobile-menu-open');
    };
  }, [isMenuOpen]);

  // Close menu on route change
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  // Close menu on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close mobile menu when clicking on a nav link
  const handleNavLinkClick = () => {
    setIsMenuOpen(false);
  };

    const getPageClass = () => {
    const path = location.pathname;
    switch (path) {
      case '/':
        return 'home-page';
      case '/about':
        return 'about-page';
      case '/events':
        return 'events-page';
      case '/gallery':
        return 'gallery-page';
      case '/blogs':
        return 'blog-page';
      case '/magazine':
        return 'magazine-page';
      default:
        return 'home-page';
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''} ${getPageClass()} ${isSplashActive ? 'splash-active' : 'splash-docked'}`}>
      <div className="header-container">
        {/* Logo Section - Left Side */}
        <div className="logo-section">
          <Link to="/" className="logo" onClick={handleNavLinkClick}>
            <picture>
              <source srcSet={logoWebp} type="image/webp" />
              <img 
                src={logo} 
                alt="Club Logo" 
                className="logo-icon" 
                width="240" 
                height="314" 
                fetchpriority="high" 
              />
            </picture>
            <div className="logo-text">
              <span className="logo-marathi">स्वराज्य</span>
              <span className="logo-english">SWARAJYA</span>
            </div>
          </Link>
        </div>

        {/* Navigation Menu - Right Side */}
        <nav 
          className={`nav-menu ${isMenuOpen ? 'nav-menu-open' : ''}`}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setIsMenuOpen(false);
            }
          }}
        >
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink 
                to="/" 
                className="nav-link" 
                onClick={handleNavLinkClick}
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                to="/about" 
                className="nav-link" 
                onClick={handleNavLinkClick}
              >
                About Us
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                to="/events" 
                className="nav-link" 
                onClick={handleNavLinkClick}
              >
                Events
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                to="/gallery" 
                className="nav-link" 
                onClick={handleNavLinkClick}
              >
                Gallery
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                to="/blogs" 
                className="nav-link" 
                onClick={handleNavLinkClick}
              >
                Blog
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                to="/magazine" 
                className="nav-link" 
                onClick={handleNavLinkClick}
              >
                Magazine
              </NavLink>
            </li>
          </ul>
        </nav>

        {/* Mobile Menu Toggle */}
        <button 
          className={`mobile-menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>
    </header>
  );
}